import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty, translate } from '../../utils/util';
import LinePickingService from '../../services/LinePickingService';
import { Select } from './ComponentsUI';

const SelectMappingModelUse = (props) => {
    const [mapping, setMapping] = useState([]);

    useEffect(() => {
        if (!isNullOrEmpty(props.partNumber)) {
            props.getPartnumbersUseModelAll({ partNumber: props.partNumber }, (data) => {
                setMapping([...data]);
                if (props.setDefaultValues) {
                    props.setDefaultValues(data);
                }
            });
        }
        // eslint-disable-next-line
    }, [props.partNumber]);

    const renderLabel = () => {
        return `${translate('mapping:use', 'line-picking')}/${translate('mapping:model', 'line-picking')}`
    }

    const onChange = (item) => {
        if (props.onChange) {
            const selectedOptions = item.currentTarget.selectedOptions;
            if (selectedOptions.length > 0) {
                props.onChange(Array.from(selectedOptions).map(x => x.value));
            }
        }
    }

    return (
        <Select
            {...props}
            id={props.name}
            name={props.name}
            display="description"
            label={renderLabel()}
            change={onChange}
            changeAll={onchange}
            multiple={true}
            notOption={true}
            placeHolder={translate('general:choose-one-option')}
            disablePlaceHoderSelect={true}
            data={mapping ? mapping.map((i) => {
                return { id: i.id, text: `${i.use.toString()}-${i.model.toString()}` };
            }) : []}
        />
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPartnumbersUseModelAll: (filter, callback) => {
            dispatch(LinePickingService.getPartnumbersUseModelAll(filter, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectMappingModelUse));
